/*
** constants and default values for <tag-input>
 */

export const /** @type {?} */ PLACEHOLDER = '+ Tag';
export const /** @type {?} */ SECONDARY_PLACEHOLDER = 'Enter a new tag';
export const /** @type {?} */ KEYDOWN = 'keydown';
export const /** @type {?} */ KEYUP = 'keyup';
export const /** @type {?} */ FOCUS = 'focus';
export const /** @type {?} */ MAX_ITEMS_WARNING = 'The number of items specified was greater than the property max-items.';

export const /** @type {?} */ ACTIONS_KEYS = {
    DELETE: 'DELETE',
    SWITCH_PREV: 'SWITCH_PREV',
    SWITCH_NEXT: 'SWITCH_NEXT',
    TAB: 'TAB'
};

export const /** @type {?} */ KEY_PRESS_ACTIONS = {
    8: ACTIONS_KEYS.DELETE,
    37: ACTIONS_KEYS.SWITCH_PREV,
    39: ACTIONS_KEYS.SWITCH_NEXT,
    9: ACTIONS_KEYS.TAB
};

export const /** @type {?} */ DRAG_AND_DROP_KEY = 'Text';
export const /** @type {?} */ NEXT = 'NEXT';
export const /** @type {?} */ PREV = 'PREV';

